import {SystemService} from './system.service';

export const SystemInjectables: Array<any> = [
  {
    provide: SystemService,
    useClass: SystemService,
  },
];
